import React from 'react'
import './Highlights.css';
import Highlight from './Components/Highlight';
export default function Highlights() {
    return (
        <section className='section-highlights'>
            <div className="content">
                <Highlight count='500' subtitle='Clients' />
                <Highlight count='14' subtitle='Years of Experience' />
                <Highlight count='10' subtitle='Years with Globe' />

            </div>
        </section>
    )
}
